import React from 'react';
import AnamnesisFormulario from '../components/AnamnesisFormulario';
import '../styles/Reserva.css';

const Anamnesis = () => {

    return (
        <div className="anamnesis-container">
            <AnamnesisFormulario />
        </div>
    );
};

export default Anamnesis;